const Folder = {

    "premise": "Premise",
    "folder_name": "Folder Name",
    "description": "Description",
    "search": "Search",
    "file_count": "Files",
    "no_folders": "No folders found",
    "no_folders_hint": "Create a folder to start organizing your documents.",
    "open_folder": "Open folder",

    "folder": "Folder",

    "error_premise": "Select Premise",
    "error_folder_name": "Enter Folder Name",

    "table_premise": "PREMISE",
    "table_name": "NAME",
    "table_description": "DESCRIPTION",
    "table_file_count": "FILES",
}

export default Folder;